import { createTheme, globalTheme } from '@cld/component-theme';

export const checkerboardTheme = createTheme({
  color1: globalTheme.color.gray40,
  color2: globalTheme.color.gray50,
  size: 15,
});
